// extracted by mini-css-extract-plugin
module.exports = {"info":"info___160QT","cover":"cover___2Cy1S"};